module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"users":{"show":{"meta_tags":{"description":"%{name} is on CAPinside. Become part of a new investment culture. Register for free - Over 25,000 investment professionals."}}}}}}}')
  delete Component.options._Ctor
}
